import { fromClass } from "fw-model";
import { SearchResult } from "./search-result";
import { SelectionItem } from "./definitions";

export enum FilterKeys {
    selectedOrganization,
    selectedApplicationSource,
    selectedDate
}

export enum ImportStatuses {
    Pending = 0,
    Processing = 1,
    Success = 2,
    PartialSuccess = 3,
    Failed = 4
}

export type AtsImportFilter = {
    casEnvironment?: string;
    organization?: string;
    source?: string;
    status?: number;
    range?: string | [];
    isLatest?: boolean;
    origin?: string;
    originEnvironment?: string;
    originTag?: string;
};

export class ImportTaskSearchResult extends SearchResult<AtsImportTaskInfo> {}

export class AtsImportRetry {
    Id: string;
}

export class AtsImportTaskMetaData {
    ApplicationSourceId: string;
    DateCompletedUtc: string;
    DateCreatedUtc: string;
    DateUpdatedUtc: string;
    HasOutputFiles: boolean;
    OrganizationId: string;
    Duration: number;
    DurationPerRecord: number;
    ProcessingDelay: number;
    Origin: string;
    OriginEnvironment: string;
    OriginTags: string[];
}

export class AtsImportTaskExtended {
    Id: string;
    EphemeralLogFileUrl: string;
    EphemeralOriginalFileUrl: string;
    log: string;
}

export class AtsImportTask {
    Id: string;
    DeletedRecordCount: number;
    FailedRecordCount: number;
    FileDateUtc: string;
    FileName: string;
    ProcessedRecordCount: number;
    TotalRecordCount: number;
    Status: ImportStatuses;
    @fromClass MetaData: AtsImportTaskMetaData;
}

export class AtsImportTaskInfo {
    ApplicationSourceId: string;
    ApplicationSourceName: string;
    OrganizationId: string;
    OrganizationName: string;
    @fromClass History: AtsImportTask;
    @fromClass Extended: AtsImportTaskExtended;
}

export const METRIC_TYPES = [
    { label: "Duration", value: "avg_metaData.duration", hexColor: "#5571AD" },
    { label: "Duration Per Record", value: "avg_metaData.durationPerRecord", hexColor: "#b4bd00" },
    { label: "Processing Delay", value: "avg_metaData.processingDelay", hexColor: "#55b8d4" }
];
